import script from "./marker.vue?vue&type=script&lang=js"
export * from "./marker.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__